import Start_Main_Register_Form from "./Start_Main_Register_Form";
import { Outlet } from "react-router-dom";
import React from "react";

class Start_Main_SignUp extends React.Component {
    render() {
        return(
            <div className="start_main_signUp">
                <h2 className="start_main_signUp_heading">Create your account</h2>
                <Start_Main_Register_Form />
                <Outlet />
            </div>
        )
    }
}

export default Start_Main_SignUp;